module.exports = __webpack_public_path__ + "static/media/carlsberg.7ece002a.jpg";